import { NgModule } from '@angular/core';
import { NgRenaultFeedbackComponent } from './ng-renault-feedback.component';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        NgRenaultFeedbackComponent
    ],
    exports: [NgRenaultFeedbackComponent]
})
export class NgRenaultFeedbackModule {

  constructor() { }
  
}
